"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ellipsis = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function Ellipsis({ color = '#7f58af', size = 80, className, style, ...rest }) {
    const circles = [...Array(4)].map((_, index) => ((0, jsx_runtime_1.jsx)("div", { style: { background: `${color}` } }, index)));
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-ellipsis'], className), style: { ...style, width: size, height: size }, ...rest, children: circles }));
}
exports.Ellipsis = Ellipsis;
//# sourceMappingURL=ellipsis.js.map